import { type VFC } from 'react'

import { TENANT_FR, TENANT_IT } from 'shared/consts'
import { CSW_ON_SERP, EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import Experiment from 'views/components/utils/optimizely/Experiment'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import CswOnSerp from './'

type CswOnSerpExperimentProps = {
  query: string
}

const CswOnSerpExperiment: VFC<CswOnSerpExperimentProps> = ({ query }) => {
  const {
    publicRuntimeConfig: {
      publicConfig: {
        crosssell: { widgets },
        searchConfig: { specialSearchTerms },
        tenant,
      },
    },
  } = useShopAndRuntimeConfig()

  return (
    <Experiment name={CSW_ON_SERP}>
      {({ isEnabled, variant }) => {
        if (
          isEnabled &&
          (tenant === TENANT_FR || tenant === TENANT_IT) &&
          specialSearchTerms
            ?.map(term => term.toLowerCase())
            ?.includes(query?.toLowerCase())
        ) {
          return (
            <div
              className={
                variant === EXPERIMENT_VARIATION.V1
                  ? 'u-hidden cswOnFilter'
                  : ''
              }
            >
              <CswOnSerp query={query} widgets={widgets} />
            </div>
          )
        }
        return null
      }}
    </Experiment>
  )
}

export default withShopAndRuntimeConfig(CswOnSerpExperiment)
